if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    

    // onSubmitHandler(evt) {
    //   evt.preventDefault();
    //   if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

    //   this.handleErrorMessage();

    //   this.submitButton.setAttribute('aria-disabled', true);
    //   this.submitButton.classList.add('loading');
    //   this.querySelector('.loading-overlay__spinner')?.classList.remove('hidden');

    //   const config = fetchConfig('javascript');
    //   config.headers['X-Requested-With'] = 'XMLHttpRequest';
    //   delete config.headers['Content-Type'];

    //   const formData = new FormData(this.form);
    //   if (this.cart) {
    //     formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
    //     formData.append('sections_url', window.location.pathname);
    //     this.cart.setActiveElement(document.activeElement);
    //   }
    //   config.body = formData;

    //   fetch(`${routes.cart_add_url}`, config)
    //     .then((response) => response.json())
    //     .then((response) => {
    //       if (response.status) {
    //         publish(PUB_SUB_EVENTS.cartError, {source: 'product-form', productVariantId: formData.get('id'), errors: response.description, message: response.message});
    //         this.handleErrorMessage(response.description);

    //         const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
    //         if (!soldOutMessage) return;
    //         this.submitButton.setAttribute('aria-disabled', true);
    //         this.submitButton.querySelector('span').classList.add('hidden');
    //         soldOutMessage.classList.remove('hidden');
    //         this.error = true;
    //         return;
    //       } else if (!this.cart) {
    //         window.location = window.routes.cart_url;
    //         return;
    //       }

    //       if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form', productVariantId: formData.get('id')});
    //       this.error = false;
    //       const quickAddModal = this.closest('quick-add-modal');
    //       if (quickAddModal) {
    //         document.body.addEventListener('modalClosed', () => {
    //           setTimeout(() => { this.cart.renderContents(response) });
    //         }, { once: true });
    //         quickAddModal.hide(true);
    //       } else {
    //         this.cart.renderContents(response);
    //       }
    //     })
    //     .catch((e) => {
    //       console.error(e);
    //     })
    //     .finally(() => {
    //       this.submitButton.classList.remove('loading');
    //       if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
    //       if (!this.error) this.submitButton.removeAttribute('aria-disabled');
    //       this.querySelector('.loading-overlay__spinner')?.classList.add('hidden');
    //     });
    // }

    async onSubmitHandler(evt) {
  evt.preventDefault();

  if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

  const quantityInput = this.form.querySelector('[name="quantity"]');
  const variantInput = this.form.querySelector('[name="id"]');

  if (quantityInput && variantInput) {
    const variantId = variantInput.value;
    const inventoryMax = parseInt(quantityInput.dataset.inventoryMax || quantityInput.dataset.max || quantityInput.max, 10);
    const requestedQty = parseInt(quantityInput.value || 1, 10);

    if (inventoryMax) {
      try {
        const cartResponse = await fetch('/cart.js');
        const cartData = await cartResponse.json();

        const cartItem = cartData.items.find(function(item) {
          return String(item.variant_id) === String(variantId);
        });

        const cartQty = cartItem ? cartItem.quantity : 0;
        const remainingQty = inventoryMax - cartQty;

        if (remainingQty <= 0) {
          quantityInput.value = 0;
          this.submitButton.setAttribute('disabled', 'disabled');
          this.submitButton.setAttribute('aria-disabled', 'true');
          this.handleErrorMessage('You already have all available stock in your cart.');
          return;
        }

        if (requestedQty > remainingQty) {
          quantityInput.value = remainingQty;
          this.handleErrorMessage(`Only ${remainingQty} more can be added. You already have ${cartQty} in your cart.`);
          return;
        }
      } catch (error) {
        console.error(error);
      }
    }
  }

  this.handleErrorMessage();

  this.submitButton.setAttribute('aria-disabled', true);
  this.submitButton.classList.add('loading');
  this.querySelector('.loading-overlay__spinner')?.classList.remove('hidden');

  const config = fetchConfig('javascript');
  config.headers['X-Requested-With'] = 'XMLHttpRequest';
  delete config.headers['Content-Type'];

  const formData = new FormData(this.form);

  if (this.cart) {
    formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
    formData.append('sections_url', window.location.pathname);
    this.cart.setActiveElement(document.activeElement);
  }

  config.body = formData;

  fetch(`${routes.cart_add_url}`, config)
    .then((response) => response.json())
    .then((response) => {
      if (response.status) {
        publish(PUB_SUB_EVENTS.cartError, {
          source: 'product-form',
          productVariantId: formData.get('id'),
          errors: response.description,
          message: response.message
        });

        this.handleErrorMessage(response.description);

        const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
        if (!soldOutMessage) return;

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.querySelector('span').classList.add('hidden');
        soldOutMessage.classList.remove('hidden');
        this.error = true;
        return;
      } else if (!this.cart) {
        window.location = window.routes.cart_url;
        return;
      }

      if (!this.error) {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'product-form',
          productVariantId: formData.get('id')
        });
      }

      this.error = false;

      const quickAddModal = this.closest('quick-add-modal');

      if (quickAddModal) {
        document.body.addEventListener('modalClosed', () => {
          setTimeout(() => {
            this.cart.renderContents(response);
          });
        }, { once: true });

        quickAddModal.hide(true);
      } else {
        this.cart.renderContents(response);
      }
    })
    .catch((e) => {
      console.error(e);
    })
    .finally(() => {
      this.submitButton.classList.remove('loading');

      if (this.cart && this.cart.classList.contains('is-empty')) {
        this.cart.classList.remove('is-empty');
      }

      if (!this.error) {
        this.submitButton.removeAttribute('aria-disabled');
      }

      this.querySelector('.loading-overlay__spinner')?.classList.add('hidden');
    });
}

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
